<template>
  <CenteredLayout>
    <v-row id="announcements-carousel" no-gutters v-if="announcements.length">
      <v-col class="mx-5 mx-lg-0">
        <Marquee
          :style="{zIndex: '-1'}"
          v-if="$vuetify.breakpoint.mobile  && !openPopupOfferApp"
          :items="announcements" />
        <CarouselMarquee
          v-if="!$vuetify.breakpoint.mobile && announcements.length > 0"
          :items="announcements"
          viewHtml="login"/>
      </v-col>
    </v-row>
    <v-row
      no-gutters
      justify="center"
      style="width:100%;"
      v-bind:class="[($vuetify.breakpoint.mdAndUp ? 'mt-2' : 'mt-12')]"
    >
      <v-col cols="12" sm="6" lg="3" class="text-center pa-2">
        <!-- <img class="logo" alt="MiCentroServicios logo" src="@/assets/logo_large.png" /> -->
        <a href="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/" target="_blank">
          <img
            class="logo"
            alt="ayudaDIGITAL logo"
            src="@/assets/logo-ayuda.svg"
            v-bind:style="{maxHeight: '95px'}"
          />
        </a>
      </v-col>
    </v-row>

    <v-row no-gutters justify="center">
      <v-alert
        class="white--text mt-1"
        color="#f695a4"
        v-show="error"
        v-if="errorCode && errorCode != 400"
      >
        <AlertError
          :error-code="errorCode"
          :errorLogin="errorLogin"
        />
      </v-alert>

      <v-alert
        class="white--text mt-1"
        color="#f695a4"
        v-show="!robot && credentials"
      >
        <v-icon>mdi-alert-circle-outline</v-icon> Debe acreditar que no es un robot
      </v-alert>
      <!-- siglo -->
      <v-alert
        class="white--text mt-1"
        color="#FBF5F0"
        v-show="messageSiglo"
      >
        <v-icon color="error">mdi-alert</v-icon>
         <span class="warningText">
            {{$t('views.home.notSession')}} soporte.proveedores.sc.sspa@juntadeandalucia.es</span>
      </v-alert>
    </v-row>

    <v-row no-gutters justify="center" style="width:100%;">
      <div :width="formWidth" class="formClass">
        <v-card-text v-if="!loadingBopsid" class="pa-0">
          <v-form ref="form">
            <v-text-field
              :loading="loading"
              :placeholder="$t('input.user')"
              persistent-placeholder
              type="text"
              v-model="user"

              persistent-hint
              name="user"
              prepend-icon="mdi-account"
              @mouseup="clearErrors"
            ></v-text-field>

            <v-text-field
              id="password"
              type="password"
              :loading="loading"
              :placeholder="$t('input.password')"
              persistent-placeholder
              name="password"
              prepend-icon="mdi-lock"
              v-model="password"
              @keyup.enter="login"
              @mouseup="clearErrors"
              @focus="handlefocus"
              @keyup="handlekeyup"
            ></v-text-field>
            <p class="warningMayus" v-if="showMayus">Bloq Mayús activado</p>

            <div class="forgotRemember d-flex flex-wrap-reverse justify-space-between pt-5">
              <a
                class="forgotPasswordLink"
                :href="$getConst('url.passwordReset')"
              >
                {{ $t('views.login.forgotPassword') }}
              </a>
              <v-switch
                class="v-input--reverse"
                :label="$t('views.login.remember')"
                hide-details
                v-model="storeUser"
              ></v-switch>
            </div>

            <!-- <v-row align="center" justify="center" no-gutters class="my-2">
              <VueRecaptcha
                :loadRecaptchaScript="true"
                :sitekey="$getConst('recaptchaKey')"
                ref="recaptcha"
                @verify="onVerify"
              />
            </v-row> -->

            <div class="d-flex flex-row align-center justify-center mt-5">
              <v-btn
                class="loginButton white--text"
                @click.stop="login"
              >
                {{ $t('views.login.signin') }}
              </v-btn>
            </div>
          </v-form>
        </v-card-text>

        <v-card-text v-if="loadingBopsid" class="text-center">
          <v-icon size="56" class="mdi-spin">mdi-loading</v-icon>
        </v-card-text>

        <v-snackbar
          v-model="snackbar"
          bottom
          color="error"
          multi-line
          v-if="message"
          timeout="-1"
        >
          {{ $t(`views.login.messages.${message}`) }}
          <template v-slot:action="{ attrs }">
            <v-btn
              dark
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              {{ $t('commons.close') }}
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </v-row>
    <v-row
      id="bottom-logo"
      no-gutters
      class="mt-4 mt-md-0"
      v-bind:style="[($vuetify.breakpoint.mdAndUp ? {} : {maxHeight: '60px'})]"
    >
      <v-col
        cols="12"
        v-bind:class="[($vuetify.breakpoint.mdAndUp ? 'text-right' : 'text-right mt-10')]"
      >
        <a href="https://www.juntadeandalucia.es/" target="_blank">
            <img
              v-bind:class="[(error ? 'logo ma-1' : 'logo ma-2')]"
              alt="Junta logo"
              src="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/sites/default/files/repositorio/2025-11/logo-junta.svg"
              :style="[
                { marginRight: '0px !important' },
                $vuetify.breakpoint.mdAndUp
                  ? { maxHeight: '60px' }
                  : { maxHeight: '40px' }
              ]"
            />
          </a>
        <a href="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/" target="_blank">
          <img
            v-bind:class="[(error ? 'logo ma-1' : 'logo ma-2')]"
            alt="SAS logo"
            src="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/repositorio/logotipo-sas"
            :style="[
              { marginLeft: '0px !important' },
              $vuetify.breakpoint.mdAndUp
                ? { maxHeight: '60px' }
                : { maxHeight: '40px' }
            ]"
          />
        </a>
      </v-col>
    </v-row>

    <!-- Pop-up-OfferApp -->
    <transition name="slide-fade">
      <div class="popupOffer" v-if="openPopupOfferApp && offerApp" >
        <v-card class="popup-card"
        :style="{
          width: screenWidth + 'px',
          display: 'flex',
          flexDirection: 'column'}">
          <div class="closePopupBtn">
            <v-icon
            id="closePopupOfferApp"
            :style="{color: 'black !important'}"
            @click="openPopupOfferApp = false"
            >
            mdi-close
            </v-icon>
          </div>
          <div v-html="offerApp.zinfo_usuariofinal"></div>
        </v-card>
      </div>
    </transition>
    <!-- Pop-up -->
    <transition name="slide-fade">
      <div class="popup" v-if="!openPopupOfferApp && openPopup && popUpData" >
        <v-card class="popup-card" :style="{ width: screenWidth / 4 + 'px' }">
          <div class="closePopupBtn">
            <v-icon
            :style="{color: 'white'}"
            @click="openPopup = false"
            >
            mdi-close
            </v-icon>
          </div>
          <div v-html="popUpData.zinfo_usuariofinal"></div>
        </v-card>
      </div>
    </transition>

  </CenteredLayout>
</template>

<script>
import { mapState } from 'vuex';
import { io } from 'socket.io-client';
import platform from 'platform';
import { CenteredLayout } from '@/layouts';
import { STATUS as SESSION_STATUS } from '@/store/modules/session';
// import { STATUS as ANNOUNCEMENTS_STATUS } from '@/store/modules/announcements';
import { Marquee, CarouselMarquee, AlertError } from '@/components';
// import VueRecaptcha from 'vue-recaptcha';

export default {
  // components: { CenteredLayout, Marquee, VueRecaptcha },
  components: {
    CenteredLayout,
    Marquee,
    CarouselMarquee,
    AlertError,
  },
  props: {
    redirect: String,
    bopsid: String,
    onlyAccessPulso: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    renderHTML(value) {
      const div = document.createElement('div');
      div.innerHTML = value;
      return div.textContent;
    },
  },
  data(props) {
    return {
      user: this.$store.state.login.storedUser || '',
      password: '',
      message: props.message,
      storeUser: this.$store.state.login.storedUser !== null,
      snackbar: !!props.message,
      focused: false,
      autocompleted: false,
      errorMessages: [],
      errorLogin: null,
      loadRecaptchaScript: true,
      robot: true,
      credentials: false,
      openPopup: false,
      openPopupOfferApp: false,
      screenWidth: 0,
      popUpData: null,
      offerApp: null,
      isMovile: false,
      messageSiglo: null,
      bloqMayus: false,
      showMayus: false,
      inputPass: null,
      activeMayus: false,
    };
  },
  computed: {
    formWidth() {
      return this.$vuetify.breakpoint.mobile ? '350px' : '500px';
    },
    ...mapState({
      loading: ({ session: { status } }) => status === SESSION_STATUS.LOADING,
      loadingBopsid: ({ session: { status } }) => status === SESSION_STATUS.LOADING_BOPSID,
      error: ({ session: { status } }) => status === SESSION_STATUS.ERROR,
      errorCode: ({ session }) => session.errorCode,
      announcements: ({ announcements }) => announcements.list,
    }),
  },
  methods: {
    // debug(e, i) {
    //   console.log('Error en login', e, i);
    // },
    login() {
      const OS = this.getOS();
      const checkboxAction = this.storeUser ? 'storeUser' : 'clearStoredUser';
      this.$store.dispatch(`login/${checkboxAction}`, this.user);

      this.clearErrors();
      this.errorLogin = null;
      this.messageSiglo = null;
      this.$store.dispatch('session/login', {
        user: this.user,
        password: this.password,
        os: OS,
      })
        .then(() => {
          this.credentials = true;
          const user = this.$store.getters['session/user'];
          if (user?.accessType?.name === 'Accenture UI Provider PIN'
            || user?.accessType?.name === 'Accenture UI Provider DMSAS') {
            this.messageSiglo = true;
          } else if (this.robot) {
            this.$store.dispatch('session/lastSession').then(() => {
              this.focused = false;

              // this.$router.push(this.redirect);
              const { redirect, pathError } = this.$route.query;
              if (this.onlyAccessPulso) {
                this.$router.push({
                  path: redirect || '/pulsodigital',
                  query: pathError ? { pathError: true } : {},
                });
              } else {
                this.$router.push({
                  path: redirect || '/home',
                  query: pathError ? { pathError: true } : {},
                });
              }
            });
          }
        })
        .catch((err) => {
          const errorCode = this.$store.getters['session/errorCode'] || 'unkown';
          console.log('Login error:', { errorCode, err });
          this.focused = false;
          this.credentials = false;
          this.errorLogin = err.data;
          this.errorMessages.push(this.$t(`views.login.error.${errorCode}`));
          if (errorCode === 'unkown') {
            console.error('unexpected error occurred during login method', err);
          }
          console.log('Login error:', { errorCode, err, m: this.errorMessages });
        });
    },
    getOS() {
      let OS = `${platform.os.family} ${platform.os.version === null ? '' : platform.os.version}`;
      if (platform.os.family === 'Windows') {
        const agenteUsuario = navigator.userAgent;
        if (/Windows NT 6.1/.test(agenteUsuario)) {
          OS = 'Windows 7';
        } else if (/Windows NT 10.0/.test(agenteUsuario) && /Win64/.test(agenteUsuario)) {
          OS = 'Windows 11';
        } else if (/Windows NT 10.0/.test(agenteUsuario)) {
          OS = 'Windows 10';
        }
      }
      return OS;
    },
    clearErrors() {
      this.focused = true;
      this.errorMessages = [];
    },
    createWebsocket() {
      const URL = window.location.host;
      let path = '';
      if (URL === 'mics.sas.junta-andalucia.es') {
        path = '';
      } else if (URL === 'www.sspa.juntadeandalucia.es') {
        path = '/servicioandaluzdesalud/mics';
      } else if (URL === 'ws001.sspa.juntadeandalucia.es') {
        path = '/mics';
      }

      const socket = io(URL, {
        path: `${path}/socket.io`,
      });

      socket.on('newAnnouncements', (announcements) => {
        this.$store.dispatch('announcements/add', { listAnnouncements: announcements });
        this.announcements = this.$store.getters['announcements/list'];
      });

      socket.emit('connection Login', null);
    },
    handlekeyup() {
      if (this.activeMayus && document.activeElement.id === 'password') {
        this.showMayus = true;
      } else {
        this.showMayus = false;
      }
    },
    handlefocus() {
      if (this.activeMayus && document.activeElement.id === 'password') {
        this.showMayus = true;
      } else {
        this.showMayus = false;
      }
    },
    onVerify(response) {
      if (response) this.robot = true;
      else this.robot = false;
    },
    calculateScreenWidth() {
      this.screenWidth = window.innerWidth;

      if (this.screenWidth < 1000) this.openPopup = false;
    },
    handleKeydown(event) {
      const caps = event.getModifierState && event.getModifierState('CapsLock');
      this.activeMayus = caps;
      if (!caps) { this.showMayus = false; }
    },
    async getPopUpData(appPromo) {
      const primaryIndexEnv = process.env.VUE_APP_KI_POPUP_LOGIN_PRIMARY_INDEX;
      const id = process.env.VUE_APP_KI_POPUP_LOGIN_OFFER_APP;
      const filters = {
        status: '(70, 80)',
        primaryIndex: parseInt(primaryIndexEnv, 10),
        id: parseInt(id, 10),
      };
      try {
        console.log('Fetching pop-up data with filters:', filters);
        const response = await appPromo.getMenssagePopup(filters);
        const index = 0;
        this.popUpData = response.collection_message.message[index];
      } catch (error) {
        console.log(error);
      }
    },
    redirectPopUp(link) {
      const ayudaDigitalLocation = link;
      window.open(ayudaDigitalLocation, '_blank');
    },
    isMobileOrTabletBrowser() {
      /*
      No hace falta comprobar si estamos en el navegador,
      ya que el login de la app, es distinto y no pasara por esta linea
      a menos que estemos en el navegador
      */
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      // Detecta Android/iOS móvil o tablet
      const isMobile = /android|iphone|ipad|ipod|windows phone/i.test(ua);
      // Es móvil/tablet
      return isMobile;
    },
    async getPopUpOfferApp(appPromo) {
      try {
        const response = await appPromo.getMenssagePopupOfferApp();
        const index = 0;
        this.offerApp = response.collection_message.message[index];
        // Si viene zinfo_usuariofinal en el KI, se muestra el popupOfferApp
        this.openPopupOfferApp = !!this.offerApp?.zinfo_usuariofinal;
      } catch (error) {
        console.log('getPopUpOfferApp error', error);
      }
    },
  },
  async created() {
    localStorage.removeItem('suscriptorsList');
    const appPromo = this.$api.getClient('appPromo');
    if (typeof this.bopsid === 'string' && this.bopsid !== '') {
      if (this.onlyAccessPulso) {
        localStorage.setItem('onlyAccessPulso', true);
      } else {
        localStorage.removeItem('onlyAccessPulso');
      }
      // Si entramos con el parametro bopsid, verificamos la url
      try {
        await this.$store.dispatch('session/login', {
          bopsid: this.bopsid,
        });
        // this.$router.push(this.redirect);
        const { pathError } = this.$route.query;
        this.$router.push({
          path: this.redirect || '/home',
          query: pathError ? { pathError: true } : {},
        });
      } catch (ex) {
        console.error('error at bopsid auth', ex);
        // console.log('Error Bopsid status', ex);
        this.message = '';
        this.snackbar = true;
        this.focused = true;
        // Si el error es 400, significa que el bopsid no es valido,
        // por lo que redirigimos al login normal
        if (ex.status === 400) {
          console.log('err 400, redirigiendo a pulsodigital');
          // Removemos la variable de acceso a pulso bopsid
          localStorage.removeItem('onlyAccessPulso');
        }
      }
    } else {
      localStorage.removeItem('onlyAccessPulso');
    }
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('onLoginView');
    }

    /* Esta funcion es la que detecta si estamos en un navegador,
    dentro de un movil/tablet, para poder ofrecer la app en el store */
    // if (this.isMobileOrTabletBrowser()) {
    //   /* Estás en un navegador en móvil o tablet (Android/iOS) */
    //   this.getPopUpOfferApp(appPromo);
    // }

    const isWebSocket = this.$store.getters['announcements/create'];
    if (!isWebSocket) {
      this.createWebsocket();
    } else {
      this.announcements = this.$store.getters['announcements/list'];
    }

    this.getPopUpData(appPromo);
    this.calculateScreenWidth();
    window.addEventListener('resize', this.calculateScreenWidth);
    window.addEventListener('keydown', this.handleKeydown);
  },
  mounted() {
    // fixes browser autocomplete label overlap
    this.$refs.form.$el.addEventListener('animationstart', (evt) => {
      this.autocompleted = evt.animationName === 'onautofillstart';
    }, true);
    this.autocompleted = true;
    setTimeout(() => {
      if (this.screenWidth >= 1000) this.openPopup = true;
    }, 500);
    this.calculateScreenWidth();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateScreenWidth);
    window.removeEventListener('keydown', this.keyEventListener);
  },
};
</script>

<style lang="scss" scoped>
img.logo {
  max-width: 100%;
}

.fade-transition-leave,
.fade-transition-leave-to {
  display: none !important;
}
.slide-fade-enter-active {
  transition: all .8s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
{
  transform: translateX(1000px);
  opacity: 0;
}
</style>

<style lang="scss">
  .container--fluid {
    background: url("./../assets/background-login.png") no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    min-height: 100%;
    overflow-y: auto;
  }

  div[role="alert"] {
    margin: 0;
    text-align: center;
    width: 100%;
    .v-icon {
      color: #cc0951;
    }
  }

  .forgotRemember {
    font-size: 12px;
    a {
      padding: .9em;
    }
    label {
      padding: 1em;
    }
  }

  .v-input--selection-controls {
    margin: 0px;
    padding: 0px;
    margin-left: 4rem;
  }

  .v-input--reverse .v-input__slot {
    flex-direction: row-reverse;
    justify-content: flex-end;
    .v-application--is-ltr & {
      .v-input--selection-controls__input {
        margin-right: 0;
        margin-left: 8px;
      }
    }
    .v-application--is-rtl & {
      .v-input--selection-controls__input {
        margin-left: 0;
        margin-right: 8px;
      }
    }
  }

  .v-input--reverse label {
    color: #27846D !important;
    font-size: 12px;
  }

  .v-messages__message {
    font-size: 10px;
  }

  .loginButton {
    position: relative;
    font-weight: bold;
    font-size: .75em;
    width: 250px;
    height: 62px !important;
    box-shadow: 0 12px 34px -10px #45a78f;
    border-radius: 2.625em;
    z-index: 1;
  }

  .loginButton::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(45deg, #01968B, #0D9B83, #2DA76E, #62BC4C, #A3D521);
    opacity: 1;
    transition: opacity 0.3s linear;
    border-radius: 2.625em;
    box-shadow: 0 0px 0px 0px transparent;
    z-index: -1;
  }

  .loginButton:hover::before {
    opacity: 0;
  }

  .loginButton::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(45deg, #A3D521, #62BC4C, #2DA76E, #0D9B83, #01968B);
    opacity: 0;
    transition: opacity 0.3s linear;
    border-radius: 2.625em;
    box-shadow: 0 0px 0px 0px transparent;
    z-index: -1;
  }

  .loginButton:hover::after {
    opacity: 1;
  }

  #bottom-logo {
    margin-top: 95px !important;
  }

  .formClass .theme--light.v-icon {
    color: #333333 !important;
  }

  .v-messages__message {
    font-size: 10.4px !important;
  }

  .popupTitle{
    word-break: keep-all;
    text-align: center;
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &-icon{
      width: 100%;
      text-align: right;
      position: relative;

    }
  }

  .closePopupBtn {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 24px;
  }

  .popup_title{
    text-align: center;
  }

  .popup_text{
    padding: 1rem;
    text-align: center;
    margin-bottom: 0 !important;
  }

  .container_popup_button{
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }

  .image-escalate {
    width: 100%;
    height: 100%;
  }

  .popup_button{
   // background-image: linear-gradient(45deg, #A3D521, #62BC4C, #2DA76E, #0D9B83, #01968B);
    opacity: 1;
    transition: opacity 0.3s linear;
    box-shadow: 0 0px 0px 0px transparent;
    border-radius: 2.6rem;
    text-align: center;
    padding: 1rem 2rem;
    color: white !important;
    margin-bottom: 1rem;
    text-transform: uppercase;
    text-decoration: none;
    font-size: 13.125px;
    font-weight: 700;
    width: fit-content !important;
    height: 50px !important;
    box-shadow: 0 12px 34px -10px #45a78f;
    border-radius: 2.625em;
    z-index: 1;
    position: relative;
  }
  .popup_button::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(45deg, #A3D521, #62BC4C, #2DA76E, #0D9B83, #01968B);
    opacity: 1;
    transition: opacity 0.3s linear;
    border-radius: 2.625em;
    box-shadow: 0 0px 0px 0px transparent;
    z-index: -1;
  }
  .popup_button:hover::before {
    opacity: 0;
  }
  .popup_button::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(45deg, #01968B, #0D9B83, #2DA76E, #62BC4C, #A3D521);
    opacity: 0;
    transition: opacity 0.3s linear;
    border-radius: 2.625em;
    box-shadow: 0 0px 0px 0px transparent;
    z-index: -1;
  }
  .popup_button:hover::after {
    opacity: 1;
  }

  .popup{
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    right: 0;
    position: fixed;
    width: auto;
    z-index: 202;
    justify-content: right;
    margin: 24px;
    &-card {
      max-width: 400px;
      box-shadow: 0px 3px 20px -5px rgba(0, 0, 0, 0.2),
      5px 4px 20px -5px rgba(0, 0, 0, 0.14),
      0px 1px 20px -5px rgba(0, 0, 0, 0.12) !important;
    }
  }

  .popupOffer{
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 202;
    margin-top: -56px;
    justify-content: right;
  }

  .warningMayus{
    font-size: 10.4px !important;
    padding-left: 33px !important;
    color: #b64351 !important;
  }

  @media (min-width: 960px) {
    #announcements-carousel,
    #bottom-logo {
      position: absolute;
      left: 12px;
      right: 12px;
      margin-top: 16px !important;
    }

    #announcements-carousel {
      top: 12px;
    }

    #bottom-logo {
      bottom: 0;
    }

    .v-input--reverse label {
      color: #27846D !important;
      font-size: 14px;
    }

    .v-messages__message {
      font-size: 12px;
    }

    div[role="alert"] {
      margin: 0;
      text-align: center;
      width: 30%;
    }

    .forgotRemember {
      font-size: 14px;
      a {
        padding: .5em;
      }
      label {
        padding: .5em;
      }
    }
  }
  .warningText{
    color:#f57c00 !important
  }

  @media (max-width: 600px) {
    .formClass {
      width: 350px !important;
    }
    #bottom-logo {
      margin-top: 0px !important;
    }
    #bottom-logo div {
      text-align: center !important;
    }
    #bottom-logo .logo {
      max-height: 45px !important;
    }
    .v-application .pt-5 {
      padding-top: 0px !important;
    }
    .forgotRemember {
      margin-left: 30px;
    }
    .forgotPasswordLink {
      margin-left: 50px;
    }
    .v-application .mt-12 {
      margin-top: 0px !important;
    }
  }
</style>

<style scoped>
  .v-text-field__details{
    display: none;
  }
</style>
